import React, { useRef, useState } from 'react'
import classNames from 'classnames'
import s from './DatePicker.less'
import { shouldInputBePolyfilled } from './polyfill'
import { getCurrentDateISO, getFutureDateISO } from '../utils/date'
// to optimize, the following polyfills may be loaded dynamically if shouldInputBePolyfilled('date') === true
import 'better-dom/dist/better-dom.js'
import 'better-dateinput-polyfill/dist/better-dateinput-polyfill.js'
import { isAndroid, isIos } from '../Device'

// webpack:BrowserOnly
const DatePicker = props => {
  const inputRef = useRef(null)
  const todayDate = getCurrentDateISO()
  const {
    name,
    value = '',
    min = todayDate,
    max = getFutureDateISO({ days: 365 }),
    label,
    className,
    classNamePolyfill,
    onChange,
    ariaLabel
  } = props

  // Accepted value property should respect ISO date format : YYYY-MM-DD
  const shouldBePolyfilled = shouldInputBePolyfilled('date')

  const shouldPolyfillPlaceHolder = isIos() || isAndroid()

  const [shouldDisplayLabel, setShouldDisplayLabel] = useState(true)

  const onDateChange = () => {
    onChange && onChange(inputRef.current.value)
  }

  const onFocus = e => {
    if (!shouldPolyfillPlaceHolder) setShouldDisplayLabel(false)
  }

  const onBlur = e => {
    if (e.target.value === '') setShouldDisplayLabel(true)
  }

  const classnames = classNames(
    s.dateInput,
    !shouldBePolyfilled && className,
    shouldBePolyfilled && s.datePolyfill,
    shouldBePolyfilled && classNamePolyfill,
    !value && shouldPolyfillPlaceHolder && s.polyfillPlaceHolder
  )

  const getLabelValue = () => {
    if (value === '' && shouldDisplayLabel) return label
    return ''
  }

  return (
    <div className={s.dateContainer}>
      <span aria-label={label} className={s.label}>
        {getLabelValue()}
      </span>
      <input
        ref={inputRef}
        type="date"
        name={name}
        className={classnames}
        required
        min={min}
        max={max}
        value={value}
        onChange={onDateChange}
        onFocus={onFocus}
        onBlur={onBlur}
        data-polyfill={shouldBePolyfilled ? 'all' : 'none'}
        aria-label={ariaLabel}
      />
    </div>
  )
}

export default DatePicker
